import React from "react";

import { IMAGES } from "@/constant";

import styles from "./warningMessage.module.css";

interface Props {
  message: string;
}
const WarningMessage: React.FC<Props> = ({ message }) => {
  return (
    <div>
      <div className={styles.approvalRequirementItem}>
        <img
          src={IMAGES.APPROVAL_DANGER_ICON}
          alt="Approval danger icon"
          className={styles.deleteIcon}
        />
        <span className={styles.deleteText}>{message}</span>
      </div>
    </div>
  );
};

export default WarningMessage;
